import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { Tables } from "@/gen/tableNames/tables";
import { createEnum } from "@/lib/utils/createEnum";
import { useTranslation } from "react-i18next";

export type M2Issuer = {
  id: number;
  name?: string;
  country?: string;
  country_name?: string;
  sector?: string;
  identification_code?: string;
  identification_code_type?: string;
  issuer_group_id?: number;
  issuer_group_name?: string;
  created_at?: string;
  updated_at?: string;
};

export const m2IssuerFields = createEnum<M2Issuer>();

export const useM2IssuerColumns = () => {
  const { t } = useTranslation([Tables.M2_ISSUERS, "tables"]);

  const columns: ColumnDef<M2Issuer>[] = [
    {
      accessorKey: m2IssuerFields.id,
      header: "Id",
    },
    {
      accessorKey: m2IssuerFields.name,
      header: () => t("columns.name", { ns: Tables.M2_ISSUERS }),
    },
    {
      accessorKey: m2IssuerFields.country_name,
      header: () => t("columns.country_name", { ns: Tables.M2_ISSUERS }),
    },
    {
      accessorKey: m2IssuerFields.sector,
      header: () => t("columns.sector", { ns: Tables.M2_ISSUERS }),
    },
    {
      accessorKey: m2IssuerFields.identification_code,
      header: () =>
        t("columns.identification_code", { ns: Tables.M2_ISSUERS }),
    },
    {
      accessorKey: m2IssuerFields.identification_code_type,
      header: () =>
        t("columns.identification_code_type", { ns: Tables.M2_ISSUERS }),
    },
    {
      accessorKey: m2IssuerFields.issuer_group_name,
      header: () =>
        t("columns.issuer_group_name", { ns: Tables.M2_ISSUERS }),
    },
    {
      id: "actions",
      cell: ({ row }) => (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue(m2IssuerFields.id)}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      ),
    },
  ];

  return columns;
};
